import { type ReactNode } from 'react'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import { ButtonGroup } from '@/components/ButtonGroup'
import { StyledLink } from '@/components/Link'
import { externalLinks } from '@/utils/link'

export interface EditProfileDialogProps {
  isOpen: boolean
  isDismissable: boolean
  isPending: boolean
  formId: string
  children: ReactNode
  onClose: () => void
  testId?: string
  closeButtonTestId?: string
  saveButtonTestId?: string
}

export function EditProfileDialog({
  isOpen,
  isDismissable,
  isPending,
  formId,
  children,
  onClose,
  testId,
  closeButtonTestId,
  saveButtonTestId,
}: EditProfileDialogProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={isDismissable}
      isUsingDialogScrolling
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Your profile details</ModalDialogTitle>
        <ModalDialogDescription>
          View or update your profile.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>{children}</ModalDialogContent>
      <ModalDialogFooter bordered compact sticky>
        <ButtonGroup stretch>
          <Button
            label="Close"
            variant="outline"
            isDisabled={isPending}
            onPress={onClose}
            testId={closeButtonTestId}
          />
          <Button
            type="submit"
            label="Save changes"
            form={formId}
            isPending={isPending}
            testId={saveButtonTestId}
          />
        </ButtonGroup>
      </ModalDialogFooter>
    </ModalDialog>
  )
}

/**
 * Edit Profile Dialog Contact Support Hint
 */
export function EditProfileDialogContactSupportHint() {
  return (
    <>
      If you want to change your email address, please{' '}
      <StyledLink
        target="_blank"
        variant="navigation"
        href={externalLinks.contactSupport()}
      >
        contact support
      </StyledLink>
      .
    </>
  )
}
